<template>
    <div id="editor">
        <editorLongTop></editorLongTop>
        <div class="main" :style="{ height: mianH + 'px' }">
            <editorLongLeft></editorLongLeft>
            <editorLongRight></editorLongRight>
        </div>
        <vipPopup></vipPopup>
    </div>
</template>

<script>
import editorLongTop from '@/components/long_novel/series/editor_long_top.vue' //编辑顶部
import editorLongRight from '@/components/long_novel/series/editor_long_right.vue' //编辑右边
import editorLongLeft from '@/components/long_novel/series/editor_long_left.vue' //编辑左边
import vipPopup from '@/components/vip_popup.vue' //vip页面
export default {
    components: {
        editorLongTop,editorLongRight,editorLongLeft,vipPopup
    },
    data() {
        return {
            mianH: 0,//主题区域宽度
        }
    },
    mounted() {
        this.calculateMianHeight();
        window.addEventListener('resize', this.calculateMianHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateMianHeight);
    },
    methods: {
        calculateMianHeight() {
            this.mianH = window.innerHeight - 80;
        }
    }
}
</script>

<style>
#editor {
    width: 100%;
    min-width: 1500px;
    height: 100vh;
    background-color: #F8F9FA;
}

#editor .main {
    width: 100%;
    min-width: 1500px;
    margin-top: 13px;
    display: flex;
}
</style>